document.addEventListener('DOMContentLoaded', function() {
  // Get all currency selectors on the page
  const currencySelectors = document.querySelectorAll('[data-currency-selector]');
  
  // Add change event listener to each selector
  currencySelectors.forEach(selector => {
    selector.addEventListener('change', function() {
      // Find the closest form and submit it
      const form = this.closest('form');
      if (form) {
        form.submit();
      }
    });
  });
});
